import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function reboot() {
    return (
        <div data-cy="historic-reboot">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.reboot" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faPowerOff} style={{ color: 'red' }} size="lg" />
            </Whisper>
        </div>
    );
}
